<template lang="pug">
option.option-base
  slot
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

/**
 * オプションタグ
 */
@Component
export default class OptionBase extends Vue {}
</script>

<style lang="stylus" scoped></style>
